import externalLinks from "@data/config/external-links.json";

/**
 * Whether an outbound link should be rendered at all.
 *
 * Returns false for links pointing at a host listed in
 * `src/data/config/external-links.json` → `unavailableHosts`, so the site does
 * not send visitors or crawlers to a destination that is currently down.
 *
 * Also returns false for an empty/missing href, which makes it a drop-in
 * replacement for the `href ? ... : null` truthiness guards already used at
 * several render sites.
 */
export function isExternalLinkAvailable(href?: string | null): boolean {
  if (!href) {
    return false;
  }
  return !externalLinks.unavailableHosts.some((host) => href.includes(host));
}
